import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import { translator } from '@/utils';
import {
  industryDetail,
  industryAddInvoiceApply
} from '@V/invoice/src/data-source/apis';
import { IndustryAddInvoiceApplyParams } from '@V/invoice/src/data-source/types';
import InvoiceOfflineDialogInfo from './invoice-offline-dialog-info.vue';
import InvoiceOfflineDialogContent from './invoice-offline-dialog-content.vue';
import InvoiceOfflineDialogAddress from './invoice-offline-dialog-address.vue';
import InvoiceOfflineDialogFile from './invoice-offline-dialog-file.vue';

type OfflineType = 1 | 2; // 1查看 2编辑/新增


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-offline-dialog',
  props: {
    remove: {},
    id: { default: null },
    title: { default: '发票详情' },
    offlineType: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const infoRef = ref(null);
const contentRef = ref(null);
const fileRef = ref(null);
const formData = ref<IndustryAddInvoiceApplyParams>({
  invoiceApplyId: null,
  industryId: null,
  industryName: '',
  aspId: null,
  aspName: '',
  invoiceType: null,
  invoiceTypeName: '',
  itemId: null,
  itemName: '',
  invoiceStatus: null,
  openAt: '',
  invoiceAmount: null,
  invoiceTitle: '',
  invoicePhone: '',
  invoiceIdentifierNo: '',
  invoiceOpenBank: '',
  invoiceBankNo: '',
  invoiceEnterpriseAddress: '',
  invoiceApplicationType: null,
  receiptFullName: '',
  receiptPhone: '',
  receiptAddress: '',
  createAt: '',
  authAt: '',
  noPassReason: '',
  invoiceOrderNo: '',
  updateAt: '',
  taskAt: '',
  detailId: null,
  isMail: null,
  companyCode: '',
  companyName: '',
  trackingNo: '',
  importType: null,
  imgList: [],
  fileList: [],
  id: props.id
});

const onConfirm = async () => {
  await Promise.all([
    infoRef.value.validate(),
    contentRef.value.validate(),
    fileRef.value.validate()
  ]);
  await industryAddInvoiceApply({
    ...formData.value,
    invoiceAmount: translator.yuan2fen(formData.value.invoiceAmount),
    imgList: formData.value.imgList.map(item => {
      return {
        ...item,
        ...(item.invoiceAmount && {
          invoiceAmount: translator.yuan2fen(item.invoiceAmount)
        })
      };
    })
  });
  XrkMessage.success('操作成功');
  props.remove();
  emits('success');
};

onMounted(async () => {
  const { id } = props;
  if (id) {
    const { data } = await industryDetail({ id });
    formData.value = {
      id,
      ...data,
      invoiceAmount: data.invoiceAmount
        ? translator.fen2yuan(data.invoiceAmount)
        : null,
      imgList: data.imgList.map(item => {
        return {
          ...item,
          ...(item.invoiceAmount && {
            invoiceAmount: translator.fen2yuan(item.invoiceAmount)
          })
        };
      })
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    class: "form-dialog form-dialog--label120 form-dialog-invoice-custom",
    title: _ctx.title,
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    showFooter: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.offlineType === 2)
        ? (_openBlock(), _createBlock(_unref(BaseButton), {
            key: 0,
            onClick: onConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(InvoiceOfflineDialogInfo, {
            ref_key: "infoRef",
            ref: infoRef,
            disabled: _ctx.offlineType === 1,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(InvoiceOfflineDialogContent, {
            ref_key: "contentRef",
            ref: contentRef,
            disabled: _ctx.offlineType === 1,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(InvoiceOfflineDialogAddress, {
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(InvoiceOfflineDialogFile, {
            ref_key: "fileRef",
            ref: fileRef,
            disabled: _ctx.offlineType === 1,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["disabled", "modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})